const hvacPlumbingElectrical = [
  {
    key: "hvac_changes",
    label: "HVAC changes",
    description: "Changes to your AC units, ducts, vents, or thermostats.",
    options: [
      { label: "No", value: "no" },
      { label: "Minor", value: "minor" },
      { label: "Major", value: "major" },
    ],
  },
  {
    key: "plumbing_changes",
    label: "Plumbing changes",
    description: "Changes to water supply, drainage, or fixture locations.",
    options: [
      { label: "No", value: "no" },
      { label: "Minor", value: "minor" },
      { label: "Major", value: "major" },
    ],
  },
  {
    key: "electrical_changes",
    label: "Electrical changes",
    description: "Changes to lighting points, switches, or distribution board.",
    options: [
      { label: "No", value: "no" },
      { label: "Minor", value: "minor" },
      { label: "Major", value: "major" },
    ],
  },
];

const furnishingAndAppliances = {
  key: "furnishing_and_appliances",
  label: "Furnishing and appliances",
  options: [
    { label: "No", value: "no" },
    { label: "Yes, I want new appliances", value: "appliances" },
    { label: "Yes, I want new furniture", value: "furniture" },
    { label: "Yes, I want both", value: "both" },
  ],
};

const fitoutType = {
  key: "fitout_type",
  label: "Fitout type",
  options: [
    { label: "Core and shell", value: "core_and_shell" },
    { label: "Fitted", value: "fitted" },
  ],
};

const furnishing = {
  key: "furnishing",
  label: "Furnishing",
  options: [
    { label: "No", value: "no" },
    { label: "Yes, I want new furniture", value: "yes" },
  ],
};

const wallDemolitions = {
  key: "wall_demolitions",
  label: "Wall demolitions",
  options: [
    { label: "No demolition", value: "no_demolition" },
    { label: "Minor demolition", value: "minor_demolition" },
  ],
};

export const SCOPE_QUESTIONS = {
  Villa: [
    {
      key: "layout_changes",
      label: "Layout changes",
      options: [
        { label: "No changes", value: "no_changes" },
        { label: "Some changes", value: "some_changes" },
        { label: "Full Redesign", value: "full_redesign" },
      ],
    },
    ...hvacPlumbingElectrical,
    {
      key: "extensions",
      label: "Extensions",
      options: [
        { label: "No", value: "no" },
        { label: "Yes, I want extensions", value: "yes" },
      ],
    },
    {
      key: "landscape",
      label: "Landscape",
      options: [
        { label: "No", value: "no" },
        { label: "Yes, I want simple landscape", value: "simple" },
        { label: "Yes, I want major landscape work", value: "major" },
      ],
    },
    furnishingAndAppliances,
  ],
  Apartment: [wallDemolitions, ...hvacPlumbingElectrical, furnishingAndAppliances],
  Airbnb: [wallDemolitions, ...hvacPlumbingElectrical, furnishingAndAppliances],
  Commercial: [fitoutType, ...hvacPlumbingElectrical, furnishing],
  Retail: [fitoutType, ...hvacPlumbingElectrical, furnishing],
  Office: [fitoutType, ...hvacPlumbingElectrical, furnishing],
};

export const SCOPE_DEFAULTS = {
  Villa: {
    layout_changes: "some_changes",
    hvac_changes: "minor",
    plumbing_changes: "minor",
    electrical_changes: "minor",
    extensions: "no",
    landscape: "no",
    furnishing_and_appliances: "no",
  },
  Apartment: {
    wall_demolitions: "no_demolition",
    hvac_changes: "minor",
    plumbing_changes: "minor",
    electrical_changes: "minor",
    furnishing_and_appliances: "no",
  },
  Airbnb: {
    wall_demolitions: "no_demolition",
    hvac_changes: "minor",
    plumbing_changes: "minor",
    electrical_changes: "minor",
    furnishing_and_appliances: "no",
  },
  Commercial: {
    fitout_type: "fitted",
    hvac_changes: "minor",
    plumbing_changes: "no",
    electrical_changes: "major",
    furnishing: "yes",
  },
  Retail: {
    fitout_type: "fitted",
    hvac_changes: "minor",
    plumbing_changes: "no",
    electrical_changes: "major",
    furnishing: "yes",
  },
  Office: {
    fitout_type: "fitted",
    hvac_changes: "minor",
    plumbing_changes: "no",
    electrical_changes: "major",
    furnishing: "yes",
  },
  Landscape: {
    inclusions: [],
  },
};

export const LANDSCAPE_INCLUSIONS = [
  { label: "Hardscape", value: "hardscape" },
  { label: "Grass", value: "grass" },
  { label: "Plants", value: "plants" },
  { label: "Kitchenette / Bar", value: "kitchenette_bar" },
  { label: "Pool", value: "pool" },
  { label: "Lighting", value: "lighting" },
  { label: "Irrigation system", value: "irrigation_system" },
  { label: "Pergola", value: "pergola" },
  { label: "Barbeque", value: "barbeque" },
  { label: "Built-in seating", value: "built_in_seating" },
  { label: "Outdoor furniture", value: "outdoor_furniture" },
];
